import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import ReviewHistoryList from './ReviewHistoryList';
const ReviewHistoryToggle = _ref => {
  let {
    pastReviews
  } = _ref;
  const [isExpanded, setIsExpanded] = useState(false);
  if (!pastReviews || pastReviews.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-2 border-start border-info border-2"
  }, /*#__PURE__*/React.createElement(Card.Body, {
    className: "py-2 px-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    size: "sm",
    onClick: () => setIsExpanded(!isExpanded),
    className: "p-0 text-decoration-none"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 align-middle"
  }, isExpanded ? 'expand_less' : 'expand_more'), /*#__PURE__*/React.createElement("span", {
    className: "ms-1"
  }, isExpanded ? 'Hide' : 'View', " Review History (", pastReviews.length, " ", pastReviews.length === 1 ? 'review' : 'reviews', ")")), isExpanded && /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(ReviewHistoryList, {
    reviewHistory: pastReviews
  }))));
};
export default ReviewHistoryToggle;